import { Form, Checkbox, Row, Col, Popover } from 'antd'
import { useEffect, useState } from 'react'
import { Language } from '../../../config/Language'

interface IProps {
    id?: string
    label: string
    name: string
    className?: string
    required?: boolean
    requiredMessage?: string
    placeholder?: string
    showTooltips?: boolean
    value?: any
    disabled?: boolean
    onChange?: any
    title?: string
    visible?: boolean
    tooltipTitle?: string
}

export const CustomCheckbox = ({ ...props }: IProps) => {
    const { getTranslation } = Language()
    const {
        id,
        label,
        name,
        className,
        required = false,
        requiredMessage = getTranslation('required'),
        visible = false,
        value,

        title,
    } = props

    const [selectedValue, setSelectedValue] = useState<any>(null)

    useEffect(() => {
        if (selectedValue !== value) {
            setSelectedValue(value)
        }
        return () => {}
    }, [value])

    return (
        <Form.Item
            id={id}
            name={name}
            className={className}
            valuePropName='checked'
            label={label}
            rules={[
                {
                    required: required,
                    message: requiredMessage,
                },
            ]}>
            <Checkbox>{title}</Checkbox>
        </Form.Item>
    )
}
